import { styled } from '@styledComponents';
import { ECard } from '@components/ECard';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Button } from '@components/Button';

export const skewHWRatio = 0.3;
const cardHeight = '70vh';
const sectionSpacing = 6;
const contentGap = 10;
const textHeight = '430px';

export const SectionBox = styled(Box)`
  position: relative;
  height: 100vh;
  width: 100vw;
  ${themeMediaQuery('below_sm')} {
    height: calc(${cardHeight} + (2 * ${themeSpace(sectionSpacing)}) + ${themeSpace(contentGap)} + ${textHeight});
  }

  // iphone8
  @media screen and (max-width: 375px) {
    height: calc(${cardHeight} + (2 * ${themeSpace(sectionSpacing)}) + ${themeSpace(contentGap)} + ${'500px'});
  }

  // iphoneSE
  @media screen and (max-width: 320px) {
    height: calc(${cardHeight} + (2 * ${themeSpace(sectionSpacing)}) + ${themeSpace(contentGap)} + ${'600px'});
  }
`;

export const MainTextPairing = styled(TextPairing)`
  margin-top: ${themeSpace(contentGap)};
  .text-pairing-title {
    max-width: 270px;
  }
  .text-pairing-body {
    max-width: 380px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 340px;
    }
  }
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    .text-pairing-title {
      max-width: 100%;
    }
    .text-pairing-body {
      max-width: 100%;
    }
  }
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(0)};
  }
  ${themeMediaQuery('md')} {
    margin-top: ${themeSpace(contentGap)};
  }
`;

export const ExploreDesignTemplatesButtonWrapper = styled(Flex)`
  margin-top: ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    justify-content: center;
  }
`;

export const InvitationContainerColumns = styled(Columns)`
  height: 100%;
  direction: rtl;
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(sectionSpacing)};
    margin-top: ${themeSpace(sectionSpacing)};
    direction: ltr;
    padding: 0px;
  }
`;

export const InvitationColumn = styled(Columns.Column)`
  width: 48%;
  direction: ltr;
  ${themeMediaQuery('below_sm')} {
    width: 90%;
    padding: 0px;
    margin: auto;
  }
  ${themeMediaQuery('md')} {
    width: 47%;
  }
  ${themeMediaQuery('xl')} {
    width: 48%;
  }
`;

export const ECardContainer = styled(Flex)`
  width: 50vh;
  margin: auto;
  justify-content: center;
  flex-direction: column;
  align-items: left;
  height: ${cardHeight};
  ${themeMediaQuery('below_sm')} {
    height: 47vh;
    padding-top: 70px;
    align-items: center;
    position: relative;
    margin: auto;
    width: 100%;
  }
  ${themeMediaQuery('sm')} {
    height: 470px;
  }
  ${themeMediaQuery('md')} {
    height: ${cardHeight};
  }
`;

export const StyledECard = styled(ECard)`
  height: 100%;
  max-height: 750px;
  width: 50vh;
  img {
    border-radius: 0px;
  }
  ${themeMediaQuery('below_sm')} {
    width: 70%;
    margin: auto;
  }
`;

export const FirstInvitationContainer = styled(Box)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const FollowupInvitationContainer = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  clip-path: polygon(0% 100%, 100% ${100 * (1 + skewHWRatio)}%, 100% ${100 * (2 + skewHWRatio)}%, 0% 200%);
`;
